import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({ name: 'trustUrl', pure: true })
export class TrustURLPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer){}

  transform(value: string, ...args: unknown[]) {
    return this.sanitizer.bypassSecurityTrustUrl(value);
  }
}
